import React, { SetStateAction, Dispatch } from 'react';
import { logError } from 'utils/logger';
import { useSelector } from 'react-redux';
import { Info } from '@mui/icons-material';
import { PortalConfigurationType } from '@trnsact/trnsact-shared-types';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { portalConfigurationsSelectors } from 'redux/portalConfigurationReducer';
import { Divider, FormControlLabel, Stack, Switch, Typography } from '@mui/material';

interface Props {
  lender: any;
  updateLenderProfile: any;
  setLender: Dispatch<SetStateAction<any>>;
}

export const LenderSettingsTab = ({ setLender, lender, updateLenderProfile }: Props) => {
  const opportunitiesPortalConfigurations = useSelector<any, any>(state =>
    portalConfigurationsSelectors.configDataByType(state, PortalConfigurationType.Opportunities)
  );

  const allowSubmissionsV2 = opportunitiesPortalConfigurations?.jsonDefinition.config.allowSubmissionsV2 ?? false;

  const handleUpdateEnhancedSubmissionsFlow = async (nextValue: boolean) => {
    try {
      await updateLenderProfile({
        variables: {
          entityId: lender.lenderProfileId,
          fieldsObj: {
            isEnhancedSubmissionsFlowEnabled: nextValue,
          },
        },
      });

      setLender((prev: any) => ({ ...prev, isEnhancedSubmissionsFlowEnabled: nextValue }));
    } catch (err) {
      logError(err);
    }
  };

  return (
    <CardContainer style={{ height: 'calc(100% - 3.5rem)' }}>
      <Stack gap="0.5rem" height="100%">
        <Stack gap="1rem">
          <Typography variant="h6" component="span">
            Submission Flow
          </Typography>

          <FormControlLabel
            label={
              <Stack>
                <Typography variant="body1">Enhanced Submissions Flow</Typography>

                <Stack direction="row" gap="0.5rem" alignItems="center">
                  <Info color="primary" />

                  <Typography color="primary">
                    Enables the enhanced submission workflow, including structured approvals and advanced lender flows
                  </Typography>
                </Stack>
              </Stack>
            }
            control={
              <Switch
                disabled={!allowSubmissionsV2}
                checked={lender?.isEnhancedSubmissionsFlowEnabled ?? false}
                onChange={async (_, checked) => {
                  await handleUpdateEnhancedSubmissionsFlow(checked);
                }}
              />
            }
          />
        </Stack>

        <Divider />
      </Stack>
    </CardContainer>
  );
};
